<template>
  <el-row :gutter="20" v-loading="loading">
    <el-col :span="12">
      <el-card>
        <h4 class="card-title">{{ $t('HRPolicyExpress') }}</h4>
        <div class="card-content" v-if="HRList && HRList.length">
          <div class="data-list">
            <policy-express-item v-for="(item, index) in HRList" :key="item.id" :data="item" type="1" :index="index" @read="policyExpressItemClick"></policy-express-item>
          </div>
          <bsp-pagination :pager-config.sync="pagerConfigHR" @page-change="pageChangeHR"></bsp-pagination>
        </div>
        <bsp-empty small-empty v-else></bsp-empty>
      </el-card>
    </el-col>
    <el-col :span="12">
      <el-card>
        <h4 class="card-title">{{ $t('HRKnowledgePark') }}</h4>
        <div class="card-content" v-if="empList && empList.length">
          <div class="data-list">
            <policy-express-item v-for="(item, index) in empList" :key="item.id" :data="item" type="2" :index="index" @read="policyExpressItemClick"></policy-express-item>
          </div>
          <bsp-pagination :pager-config.sync="pagerConfigEmp" @page-change="pageChangeEmp"></bsp-pagination>
        </div>
        <bsp-empty small-empty v-else></bsp-empty>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
  import PolicyExpressItem from '@/views/policy/policyLibrary/policyExpress/components/PolicyExpressItem';
  import * as api from '@/api/policy/policyLibrary';
  export default {
    name: "All",
    components: {
      PolicyExpressItem
    },
    data() {
      return {
        HRList: [],
        empList: [],
        pagerConfigHR: {
          page: 1,
          limit: 10,
          total: 0
        },
        pagerConfigEmp: {
          page: 1,
          limit: 10,
          total: 0
        }
      }
    },
    created() {
      this.getData(1);
      this.getData(2);
    },
    methods: {
      /**
       * type： hr-人力资源政策速递 2-人力资源知识园地
       * @param type
       */
      getData(type) {
        this.loading = true;
        let params = {};
        if (type == 1) {
          params = {
            page1: this.pagerConfigHR.page,
            pageSize1: this.pagerConfigHR.limit
          }
        }
        if (type == 2) {
          params = {
            page2: this.pagerConfigEmp.page,
            pageSize2: this.pagerConfigEmp.limit
          }
        }
        api.humanResourcesList(params)
          .then(res => {
            this.loading = false;
            const { total, list } = res.data.data;
            if (type == 1) {
              this.HRList = list;
              this.pagerConfigHR.total = total;
            }
            if (type == 2) {
              this.empList = list;
              this.pagerConfigEmp.total = total;
            }
          })
          .catch(error =>{
            this.loading = false;
          })
      },
      // 单项点击，设为已读同时跳转至详情页
      policyExpressItemClick({ index, data, type }) {
        const { id, essayUrl } = data;
        api.expressRead({ id })
          .then(res => {
            if (type == 1) {
              this.HRList[index].read = 1;
            }
            if (type == 2) {
              this.empList[index].read = 1;
            }
          })
        window.open(essayUrl);
      },
      pageChangeHR({ type, currentPage, pageSize }) {
        if (type == 'size') {
          this.pagerConfigHR.page = 1;
        }
        this.getData(1);
      },
      pageChangeEmp({ type, currentPage, pageSize }) {
        if (type == 'size') {
          this.pagerConfigEmp.page = 1;
        }
        this.getData(2);
      }
    }
  }
</script>

<style scoped>

</style>
